import authentication from "@irati/auth"
import cardGraph from "../../graph/card"

export const LIST_CARDS = {}
export const REMOVE_CARD = {}

export const list = (cards) => {
  return {
    type: LIST_CARDS,
    cards
  }
}

export const remove = (card) => ({
  type: REMOVE_CARD,
  card
})

export const listCards = (sort = null) => {
  return (dispatch) => {
    return cardGraph.list(authentication.user().uuid, sort).then((cards) => {
      return dispatch(list(cards))
    })
  }
}

export const removeCard = (card) => {
  return (dispatch) => {
    return cardGraph.remove(card.uuid).then(() => {
      return dispatch(remove(card))
    })
  }
}

export default {
  list: listCards,
  remove: removeCard
}
